import DialogTitle from "@mui/material/DialogTitle"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"

type Props = {
  isDialogOpen: boolean
  onClick: () => void
  onClose: () => void
  title: string
  body: string
  textOk: string
  textCancel: string
}

const UserConfirmDialog = ({ isDialogOpen, onClick, onClose, title, body, textOk, textCancel }: Props) => (
  <Dialog
    open={isDialogOpen}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">{body}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>
        <span automation-name="close-dialog">{textCancel}</span>
      </Button>
      <Button onClick={onClick} color="primary">
        <span automation-name="confirm">{textOk}</span>
      </Button>
    </DialogActions>
  </Dialog>
)

export default UserConfirmDialog
